<div class="custom-security-link">
    <a [routerLink]="['/calendar']" routerLinkActive="active">Calendar</a>
    <a [routerLink]="user?.cLPCompanyID === 1226  ? ['/call-ih'] : ['/call']" routerLinkActive="active">Call List</a>
    <a [routerLink]="['/task']" routerLinkActive="active">Tasks</a>
    <a [routerLink]="['/contacts']" routerLinkActive="active">Contacts</a>
    <a [routerLink]="['/lead']" routerLinkActive="active">Leads</a>
</div>

<div class="eng-dash">

    <header class="eng-topbar">
        <div class="eng-identity">
            <h1>Engagement Summary</h1>
            <p>Leads, slidecasts, contracts, ad spend and lifetime value</p>
        </div>

        <div class="eng-controls" [class.eng-working]="isBusy">
            <div class="eng-modeswitch" role="group" aria-label="Time frame mode">
                <button type="button" [class.eng-mode-on]="compareMode" (click)="setCompareMode(true)">Time Frame</button>
                <button type="button" [class.eng-mode-on]="!compareMode" (click)="setCompareMode(false)">Date Range</button>
            </div>

            <select class="eng-select" *ngIf="compareMode" aria-label="Time frame"
                    [value]="period" (change)="onPeriodChange($any($event.target).value)">
                <option value="0">This Month</option>
                <option value="1">Last Month</option>
            </select>

            <div class="eng-range" *ngIf="!compareMode">
                <input type="date" class="eng-date" aria-label="From date"
                       [(ngModel)]="fromDate" (change)="onRangeChange()">
                <span class="eng-range-sep">to</span>
                <input type="date" class="eng-date" aria-label="To date"
                       [(ngModel)]="toDate" (change)="onRangeChange()">
            </div>

            <select class="eng-select" aria-label="Ad or marketing channel" (change)="onChannelChange($event)">
                <option value="">All channels</option>
                <option *ngFor="let c of channels" [value]="c.id">{{ c.text }}</option>
            </select>
        </div>

        <div class="eng-rangebar" *ngIf="window" [class.eng-stale]="loadingSummary"
             [attr.aria-busy]="loadingSummary ? 'true' : null">
            <span class="eng-chip">{{ window.name }}</span>
            <span class="eng-rangebar-dates">{{ window.label }}</span>
            <ng-container *ngIf="loadingSummary">
                <span class="eng-loadpip" aria-hidden="true"></span>
                <span class="eng-rangebar-note">updating&hellip;</span>
            </ng-container>
        </div>
    </header>

    <div class="eng-notice eng-notice-error" *ngIf="errorMsg">
        <span class="eng-notice-icon" aria-hidden="true">!</span>
        <p class="eng-notice-body"><strong>This report could not load in full.</strong> {{ errorMsg }}</p>
    </div>

    <div class="eng-notice eng-notice-info" *ngIf="noteMsg && !errorMsg">
        <span class="eng-notice-icon" aria-hidden="true">i</span>
        <p class="eng-notice-body"><strong>Why this report is empty.</strong> {{ noteMsg }}</p>
    </div>

    <p class="eng-kpis-failed" *ngIf="summaryError && !loadingSummary">
        The figures below could not be read.
    </p>

    <div class="eng-busywrap" [class.eng-stale]="loadingSummary">
        <div class="eng-busy" *ngIf="loadingSummary" role="status" aria-live="polite">
            <span class="eng-spinner" aria-hidden="true"></span>
            <span class="eng-sr">Loading</span>
        </div>
        <div class="eng-kpis">
        <div class="eng-stat eng-stat-hero">
            <div class="eng-stat-title">Total Leads
                <span class="eng-delta-chip" [ngClass]="deltaTone(delta(summary?.totalLeads, summary?.priorTotalLeads))"
                      *ngIf="delta(summary?.totalLeads, summary?.priorTotalLeads) != null"
                      [attr.aria-label]="deltaLabel(delta(summary?.totalLeads, summary?.priorTotalLeads))">{{ delta(summary?.totalLeads, summary?.priorTotalLeads) | percent:'1.1-1' }}</span>
            </div>
            <div class="eng-stat-value">{{ summary ? (summary.totalLeads | number) : '-' }}</div>

            <div class="eng-stat-caption" *ngIf="window">{{ window.label }}<span
                  *ngIf="summary?.priorTotalLeads != null"> &middot; vs {{ summary.priorTotalLeads | number }} prior period</span></div>
        </div>
        <div class="eng-stat eng-tint-teal">
            <div class="eng-stat-title"><span class="eng-stat-dot" aria-hidden="true"></span>Slidecasts Viewed
                <span class="eng-delta-chip" [ngClass]="deltaTone(delta(summary?.slidecastsViewed, summary?.priorSlidecastsViewed))"
                      *ngIf="delta(summary?.slidecastsViewed, summary?.priorSlidecastsViewed) != null"
                      [attr.aria-label]="deltaLabel(delta(summary?.slidecastsViewed, summary?.priorSlidecastsViewed))">{{ delta(summary?.slidecastsViewed, summary?.priorSlidecastsViewed) | percent:'1.1-1' }}</span>
            </div>

            <div class="eng-stat-value" *ngIf="summary?.slidecastsApplicable">{{ summary.slidecastsViewed | number }}</div>
            <div class="eng-stat-value eng-stat-na" *ngIf="summary && !summary.slidecastsApplicable">NA</div>
            <div class="eng-stat-value" *ngIf="!summary">-</div>
            <div class="eng-stat-caption" *ngIf="summary && !summary.slidecastsApplicable">Not attributable per channel</div>
            <div class="eng-stat-caption" *ngIf="window && summary?.slidecastsApplicable">{{ window.label }}</div>
        </div>
        <div class="eng-stat eng-tint-violet">
            <div class="eng-stat-title"><span class="eng-stat-dot" aria-hidden="true"></span>Contracts
                <span class="eng-delta-chip" [ngClass]="deltaTone(delta(summary?.contracts, summary?.priorContracts))"
                      *ngIf="delta(summary?.contracts, summary?.priorContracts) != null"
                      [attr.aria-label]="deltaLabel(delta(summary?.contracts, summary?.priorContracts))">{{ delta(summary?.contracts, summary?.priorContracts) | percent:'1.1-1' }}</span>
            </div>
            <div class="eng-stat-value">{{ summary ? (summary.contracts | number) : '-' }}</div>
            <div class="eng-stat-caption" *ngIf="window">{{ window.label }}</div>
        </div>
        <div class="eng-stat eng-tint-amber">
            <div class="eng-stat-title"><span class="eng-stat-dot" aria-hidden="true"></span>Ad Spend
                <span class="eng-delta-chip" [ngClass]="deltaTone(delta(summary?.adSpend, summary?.priorAdSpend))"
                      *ngIf="delta(summary?.adSpend, summary?.priorAdSpend) != null"
                      [attr.aria-label]="deltaLabel(delta(summary?.adSpend, summary?.priorAdSpend))">{{ delta(summary?.adSpend, summary?.priorAdSpend) | percent:'1.1-1' }}</span>
            </div>

            <div class="eng-stat-value" *ngIf="summary?.adSpendApplicable">{{ summary.adSpend | currency:'USD':'symbol':'1.0-0' }}</div>
            <div class="eng-stat-value eng-stat-na" *ngIf="summary && !summary.adSpendApplicable">NA</div>
            <div class="eng-stat-value" *ngIf="!summary">-</div>
            <div class="eng-stat-caption" *ngIf="summary && !summary.adSpendApplicable">Not attributable per channel</div>
            <div class="eng-stat-caption" *ngIf="window && summary?.adSpendApplicable">{{ window.label }}</div>
        </div>
        <div class="eng-stat eng-tint-blue">
            <div class="eng-stat-title"><span class="eng-stat-dot" aria-hidden="true"></span>LTV
                <span class="eng-delta-chip" [ngClass]="deltaTone(delta(summary?.ltv, summary?.priorLtv))"
                      *ngIf="delta(summary?.ltv, summary?.priorLtv) != null"
                      [attr.aria-label]="deltaLabel(delta(summary?.ltv, summary?.priorLtv))">{{ delta(summary?.ltv, summary?.priorLtv) | percent:'1.1-1' }}</span>
            </div>
            <div class="eng-stat-value">{{ summary ? (summary.ltv | currency:'USD':'symbol':'1.0-0') : '-' }}</div>
            <div class="eng-stat-caption" *ngIf="window">{{ window.label }}</div>
            </div>
        </div>
    </div>

    <div class="eng-row">
        <section class="eng-card" aria-labelledby="engSecDaily">
            <div class="eng-busy" *ngIf="loadingChart" role="status" aria-live="polite">
                <span class="eng-spinner" aria-hidden="true"></span>
                <span class="eng-sr">Loading</span>
            </div>
            <div class="eng-card-head">
                <h2 id="engSecDaily">Daily Leads</h2>
            </div>
            <div class="eng-card-body eng-chartbody">
                <kendo-chart [transitions]="false" [chartArea]="chartArea" *ngIf="chartValues.length">
                    <kendo-chart-tooltip [shared]="true"></kendo-chart-tooltip>

                    <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                    <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="chartCategories"
                                                        [majorGridLines]="{ visible: false }">

                            <kendo-chart-category-axis-item-labels [rotation]="-45"
                                                                   [step]="1"
                                                                   font="12px Manrope, Segoe UI, Arial, sans-serif"
                                                                   color="#64748b"></kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                    </kendo-chart-category-axis>
                    <kendo-chart-value-axis>

                        <kendo-chart-value-axis-item [title]="chartValueAxisTitle" [majorUnit]="chartMajorUnit">
                            <kendo-chart-value-axis-item-labels font="12px Manrope, Segoe UI, Arial, sans-serif"
                                                                color="#94a3b8"></kendo-chart-value-axis-item-labels>
                        </kendo-chart-value-axis-item>
                    </kendo-chart-value-axis>
                    <kendo-chart-series>

                        <kendo-chart-series-item type="column" [name]="chartSeriesName"
                                                 [data]="chartValues" [color]="seriesColor"
                                                 [gap]="0.4" [spacing]="0.25"
                                                 [labels]="chartSeriesLabels"></kendo-chart-series-item>
                    </kendo-chart-series>
                </kendo-chart>

                <p class="eng-empty eng-empty-failed" *ngIf="chartError && !loadingChart">
                    {{ chartError }}
                </p>
                <p class="eng-empty" *ngIf="!chartError && !chartValues.length && !loadingChart">
                    No leads in the selected window.
                </p>
            </div>
        </section>

        <section class="eng-card" aria-labelledby="engSecChannel">
            <div class="eng-busy" *ngIf="loadingChannels" role="status" aria-live="polite">
                <span class="eng-spinner" aria-hidden="true"></span>
                <span class="eng-sr">Loading</span>
            </div>
            <div class="eng-card-head">
                <h2 id="engSecChannel">Ad / Marketing Channel</h2>
            </div>
            <div class="eng-card-body eng-tablebody">

                <div class="eng-scroll">
                    <table class="eng-table eng-chantable" *ngIf="channelRows.length">
                        <thead>
                            <tr>
                                <th scope="col">Channel</th>

                                <th scope="col" class="eng-num eng-pct">Share</th>
                                <th scope="col" class="eng-num">Leads</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of channelRows; let i = index; trackBy: trackByChannel">
                                <th scope="row" [title]="row.channel">
                                    <span class="eng-chan-swatch" [style.background]="channelColor(i)" aria-hidden="true"></span>
                                    <span class="eng-chan-name">{{ row.channel }}</span>
                                    <span class="eng-share-track" aria-hidden="true"><span class="eng-share-fill"
                                          [style.width.%]="channelShare(row)" [style.background]="channelColor(i)"></span></span>
                                </th>
                                <td class="eng-num eng-pct">{{ channelShare(row) | number:'1.1-1' }}%</td>
                                <td class="eng-num">{{ row.leads | number }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="eng-empty eng-empty-failed" *ngIf="channelsError && !loadingChannels">
                    {{ channelsError }}
                    </p>
                    <p class="eng-empty" *ngIf="!channelsError && !channelRows.length && !loadingChannels">
                        No leads in the selected window.
                    </p>
                </div>

                <table class="eng-table eng-chantable eng-totalbar" *ngIf="channelRows.length">
                    <tbody>
                        <tr>
                            <th scope="row">Total</th>
                            <td class="eng-num eng-pct">100%</td>
                            <td class="eng-num">{{ channelTotal | number }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>

    <div class="eng-matrixbar" [class.eng-working]="isBusy">
        <label class="eng-inline-label" for="engGroupBy">Group By :</label>
        <select id="engGroupBy" class="eng-select" (change)="onGroupByChange($event)">
            <option value="0">Channel</option>
            <option value="1">SiteName</option>
        </select>

        <label class="eng-inline-label" for="engTeam">Team :</label>

        <select id="engTeam" class="eng-select eng-select-wide"
                [value]="selectedTeams.length ? selectedTeams[0] : ''" (change)="onTeamChange($event)">
            <option value="">All my teams</option>
            <option *ngFor="let t of teams" [value]="t.id">{{ t.text }}</option>
        </select>

        <label class="eng-inline-label" for="engYear">Year :</label>
        <select id="engYear" class="eng-select" [value]="year" (change)="onYearChange($event)">
            <option *ngFor="let y of years" [value]="y.id">{{ y.text }}</option>
        </select>
    </div>

    <section class="eng-card" aria-labelledby="engSecLeadGen">
            <div class="eng-busy" *ngIf="loadingLeadGen" role="status" aria-live="polite">
                <span class="eng-spinner" aria-hidden="true"></span>
                <span class="eng-sr">Loading</span>
            </div>
        <div class="eng-card-head">
            <h2 id="engSecLeadGen">Lead Generation Report</h2>

            <p class="eng-delta" *ngIf="selectedChannelName">
                <span class="eng-delta-tag">Channel filter not applied</span>
                <span><strong>{{ selectedChannelName }}</strong> is filtering the cards, the chart
                    and the channel table above. This report still shows every channel &mdash;
                    campaign records carry no channel or site to match on, so filtering it would
                    blank the advertising columns and narrow the rest.</span>
            </p>

        </div>

        <div class="eng-card-body">
            <div class="eng-scroll eng-scroll-wide">
                <table class="eng-table eng-matrix" *ngIf="leadGenRows.length">
                    <thead>
                        <tr>
                            <th scope="col" class="eng-sticky-col" title="Month">Month</th>
                            <th scope="col" class="eng-num" title="Impressions">Impressions</th>
                            <th scope="col" class="eng-num" title="Clicks">Clicks</th>
                            <th scope="col" class="eng-num" title="CTR">CTR</th>
                            <th scope="col" class="eng-num" [class.eng-col-off]="isUnavailable('CONV')" title="CONV">CONV</th>
                            <th scope="col" class="eng-num" [class.eng-col-off]="isUnavailable('CVR')" title="CVR">CVR</th>
                            <th scope="col" class="eng-num" title="Ad Spent">Ad Spent</th>
                            <th scope="col" class="eng-num" [class.eng-col-off]="isUnavailable('CPC')" title="CPC">CPC</th>
                            <th scope="col" class="eng-num" title="Total Spent">Total Spent</th>
                            <th scope="col" class="eng-num" title="ROAS">ROAS</th>
                            <th scope="col" class="eng-num" title="Leads">Leads</th>
                            <th scope="col" class="eng-num" title="CPL">CPL</th>
                            <th scope="col" class="eng-num" title="Sales">Sales</th>
                            <th scope="col" class="eng-num" title="M2L">M2L</th>
                            <th scope="col" class="eng-num" title="CPM">CPM</th>
                            <th scope="col" class="eng-num" title="Entry">Entry</th>
                            <th scope="col" class="eng-num" title="Monthly">Monthly</th>
                            <th scope="col" class="eng-num" title="Monthly Residual">Monthly Residual</th>
                            <th scope="col" class="eng-num" title="AVG LTV">AVG LTV</th>
                            <th scope="col" class="eng-num" title="LTV">LTV</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let row of leadGenRows; trackBy: trackByRow">
                            <tr *ngIf="isRowVisible(row)"
                                [class.eng-r-month]="row.level === rowLevel.Month"
                                [class.eng-r-group]="row.level === rowLevel.Group"
                                [class.eng-r-total]="row.level === rowLevel.GrandTotal"
                                [class.eng-r-alt]="isAltMonth(row)">
                                <th scope="row" class="eng-sticky-col">

                                    <button type="button" class="eng-expand"
                                            *ngIf="row.level === rowLevel.Month"
                                            (click)="toggleMonth(row.monthNumber)"
                                            [attr.aria-expanded]="isMonthOpen(row.monthNumber)"
                                            [attr.aria-label]="(isMonthOpen(row.monthNumber) ? 'Collapse ' : 'Expand ') + row.month">{{ isMonthOpen(row.monthNumber) ? '&minus;' : '+' }}</button>
                                    <span class="eng-indent" *ngIf="row.level === rowLevel.Group"></span>
                                    {{ row.level === rowLevel.Group ? row.groupValue : row.month }}
                                </th>

                                <td class="eng-num">{{ row.impressions | number }}</td>
                                <td class="eng-num">{{ row.clicks | number }}</td>
                                <td class="eng-num" [ngClass]="pctTone(row.ctr)">{{ row.ctr | percent:'1.1-1' }}</td>
                                <td class="eng-num">{{ row.conversions | number }}</td>
                                <td class="eng-num" [ngClass]="pctTone(row.cvr)">{{ row.cvr | percent:'1.1-1' }}</td>
                                <td class="eng-num">{{ row.adSpent | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.cpc | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.totalSpent | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.roas | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.totalLeads | number }}</td>
                                <td class="eng-num">{{ row.cpl | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.contracts | number }}</td>
                                <td class="eng-num">{{ row.m2L }}</td>
                                <td class="eng-num">{{ row.cpm | currency:'USD':'symbol':'1.2-2' }}</td>
                                <td class="eng-num">{{ row.initiationFee | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.membershipFee | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.monthlyResidual | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.avgLtv | currency:'USD':'symbol':'1.0-0' }}</td>
                                <td class="eng-num">{{ row.ltv | currency:'USD':'symbol':'1.0-0' }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>

                <p class="eng-empty eng-empty-failed" *ngIf="leadGenError && !loadingLeadGen">
                    {{ leadGenError }}
                </p>
                <p class="eng-empty" *ngIf="!leadGenError && !leadGenRows.length && !loadingLeadGen">
                    No leads or contracts in {{ year }}.
                </p>
            </div>

            <p class="eng-footnote" *ngIf="unavailableColumns.length">
                <strong>{{ unavailableColumns.join(', ') }}</strong> could not be computed: no
                conversions-per-team source was found on this database.
            </p>
        </div>
    </section>
</div>
